import React from 'react';
import './ButtonSpinner.scss';
import {ReactComponent as Loader} from '../../assets/spinner/button_spinner.svg';

const ButtonSpinner = () => {
    return (
         <Loader className='buttonSpinnerLoader'/>
    )
}

export default ButtonSpinner;
